module.exports = __webpack_public_path__ + "img/news_list.d179bf27.png";